
const globalSearch = {
    namespaced: true, // 开启命名空间
    state: {
       searchWord:'',
	   optionValue:''
    },
    mutations: {
         SET_WORD(state, word) {
            state.searchWord= word;
          },
		  SET_OPTION(state, value) {
		     state.optionValue= value;
		   },
    },
    actions: {},
    getters: {
      
    }
}
export default globalSearch
